export const ITEMS = [
  {
    id: 's1',
    name: 'Hp Potion',
    count: 5,
    description: 'Magic potion for healing wounds',
    stats: 'Restores 50hp',
    asset: 'hp-potion.png'
  },
  {
    id: 's2',
    name: 'Mana Potion',
    count: 5,
    description: 'Magic potion for restoring magic power',
    stats: 'Restores 50Mana',
    asset: 'mana-potion.png'
  },
  {
    id: 's3',
    name: 'Crystal Sword',
    count: 1,
    description: 'A sword made from crystal',
    stats: '12 Physical Damage',
    asset: 'crystalsword.png'
  },
  {
    id: 's4',
    name: 'Crystal Wand',
    count: 1,
    description: 'A wand  made from crystal',
    stats: '12 Magic Damage',
    asset: 'crystalwand.png'
  },
  {
    id: 's5',
    name: 'Dagger',
    count: 2,
    description: 'Small weapon good for novices',
    stats: '8 Physical Damage',
    asset: 'dagger.png'
  },
  {
    id: 's6',
    name: 'Double Axe',
    count: 1,
    description: 'For true brute force',
    stats: '20 Physical Damage',
    asset: 'doubleaxe.png'
  },
  {
    id: 's7',
    name: 'Long Sword',
    count: 1,
    description: 'Longer than you think',
    stats: '14 Physical Damage',
    asset: 'longsword.png'
  },
  {
    id: 's8',
    name: 'Ring',
    count: 1,
    description: 'Ring with magic power in it',
    stats: '+2 to all Stats',
    asset: 'ring.png'
  },
  {
    id: 's9',
    name: 'Spell Book',
    count: 1,
    description: 'Some wizards say it requires time to learn it',
    stats: '+4 Magic Damage increasing with lvl',
    asset: 'spellbook.png'
  }
];
